import { updateSettingsCommunicationChannelsApi as generatedUpdateSettingsCommunicationChannelsApi } from '../generated/settingsCommunicationChannels/updateSettingsCommunicationChannels';

const updateSettingsCommunicationChannelsApi = generatedUpdateSettingsCommunicationChannelsApi.enhanceEndpoints({
  endpoints: {
    updateSettingsCommunicationChannels: {
      invalidatesTags: ['SettingsCommunicationChannels'],
    },
  },
});

export const { useUpdateSettingsCommunicationChannelsMutation } = updateSettingsCommunicationChannelsApi;
